import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <h2 className={styles.logo}>netflixroulette</h2>
      </div>
    </footer>
  );
};
export default Footer;
